// import React, { useEffect } from "react";
// import { useParams } from "react-router-dom";
// import { useDispatch, useSelector } from "react-redux";
// import { fetchAsanaById } from "../../Redux/Action/SidebarAsanaAction";
// import "./AsanaDetails.css";
// import AdvertisementCard from "../AdvertisementCard";
// import VariationCard from "../VariationCard";

// // ✅ Helper: safely render a field that could be:
// //    - an HTML string from CKEditor  e.g. "<ul><li>Step 1</li></ul>"
// //    - a JSON-stringified HTML        e.g. '"<ul><li>Step 1</li></ul>"'
// //    - a plain array (old data)       e.g. ["Step 1", "Step 2"]
// //    - a plain string                 e.g. "Step 1"
// const renderRichField = (field) => {
//   if (!field) return null;

//   // 1️⃣ If it's an array — check if it contains HTML strings (new CKEditor format)
//   //    e.g. ["<ul><li>Step 1</li></ul>"]  → render as HTML
//   //    e.g. ["Step 1", "Step 2"]          → render as plain list (old format)
//   if (Array.isArray(field)) {
//     const isHtmlArray =
//       field.length === 1 &&
//       typeof field[0] === "string" &&
//       field[0].trim().startsWith("<");
//     if (isHtmlArray) {
//       // Unwrap and render as HTML
//       let html = field[0];
//       try {
//         const parsed = JSON.parse(html);
//         if (typeof parsed === "string") html = parsed;
//       } catch {
//         /* use as-is */
//       }
//       return (
//         <div
//           className="ck-content"
//           dangerouslySetInnerHTML={{ __html: html }}
//         />
//       );
//     }
//     // Old plain text array
//     return (
//       <ul>
//         {field.map((item, idx) => (
//           <li key={idx}>{item}</li>
//         ))}
//       </ul>
//     );
//   }

//   // 2️⃣ If it's a JSON-stringified string — unwrap it first
//   let htmlString = field;
//   if (typeof field === "string") {
//     try {
//       const parsed = JSON.parse(field);
//       if (typeof parsed === "string") htmlString = parsed;
//     } catch {
//       // Not JSON — use as-is
//     }
//   }

//   // 3️⃣ Render as HTML
//   return (
//     <div
//       className="ck-content"
//       dangerouslySetInnerHTML={{ __html: htmlString }}
//     />
//   );
// };

// const AsanaDetails = () => {
//   const { id } = useParams();
//   const dispatch = useDispatch();

//   const { selectedAsana, loading, error } = useSelector(
//     (state) => state.sideBarAsana,
//   );

//   useEffect(() => {
//     if (id) dispatch(fetchAsanaById(id));
//   }, [dispatch, id]);

//   if (loading) return <p className="page-padding">Loading...</p>;
//   if (error) return <p className="page-padding error">{error}</p>;
//   if (!selectedAsana) return <p className="page-padding">No data found.</p>;

//   return (
//     <div style={{ display: "flex", margin: "20px" }}>
//       <div className="asana-container">
//         <h1 className="asana-title">{selectedAsana.name}</h1>

//         <div className="asana-image-wrapper">
//           <img
//             src={selectedAsana.mainImage}
//             alt={selectedAsana.name}
//             className="asana-image"
//           />
//         </div>

//         <table className="asana-table">
//           <tbody>
//             <tr>
//               <th>Sanskrit</th>
//               <td>{selectedAsana.sanskrit}</td>
//             </tr>
//             <tr>
//               <th>Tamil</th>
//               <td>{selectedAsana.tamil}</td>
//             </tr>
//             <tr>
//               <th>English</th>
//               <td>{selectedAsana.english}</td>
//             </tr>
//             <tr>
//               <th>Pose Type</th>
//               <td>{selectedAsana.poseType?.join(", ")}</td>
//             </tr>
//             <tr>
//               <th>Breath</th>
//               <td>{selectedAsana.breath}</td>
//             </tr>
//             <tr>
//               <th>Level</th>
//               <td>{selectedAsana.level?.charAt(0).toUpperCase() + selectedAsana.level?.slice(1)}</td>
//             </tr>
//             <tr>
//               <th>Chakra</th>
//               <td>{selectedAsana.chakra}</td>
//             </tr>
//           </tbody>
//         </table>

//         {/* ✅ All 3 sections now render HTML from CKEditor (or fallback to old array format) */}
//         <div className="section">
//           <h2>How To Do</h2>
//           {renderRichField(selectedAsana.howToDo)}
//         </div>

//         <div className="section">
//           <h2>Benefits</h2>
//           {renderRichField(selectedAsana.benefits)}
//         </div>

//         <div className="section">
//           <h2>Precautions</h2>
//           {renderRichField(selectedAsana.precautions)}
//         </div>

//         <h2 style={{ marginBottom: "20px" }}>Variation Poses</h2>
//         <div className="asana-variation">
//           {selectedAsana.variationPoses?.length > 0 &&
//             selectedAsana.variationPoses.map((v, i) => (
//               <VariationCard v={v} key={v._id || i} />
//             ))}

//           {selectedAsana.userVariationPoses?.length > 0 &&
//             selectedAsana.userVariationPoses.map((v, i) => (
//               <VariationCard v={v} key={v._id || i} />
//             ))}
//         </div>
//       </div>
//       <AdvertisementCard />
//     </div>
//   );
// };

// export default AsanaDetails;

import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { fetchAsanaBySlug } from "../../Redux/Action/SidebarAsanaAction";
import "./AsanaDetails.css";
import { fetchSideBarAsanas } from "../../Redux/Action/SidebarAsanaAction";
import AdvertisementCard from "../AdvertisementCard";
import VariationCard from "../VariationCard";

const makeSlug = (text = "") =>
  text
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9\s-]/g, "")
    .replace(/\s+/g, "-");

// ✅ Helper: safely render a field that could be:
//    - an HTML string from CKEditor  e.g. "<ul><li>Step 1</li></ul>"
//    - a JSON-stringified HTML        e.g. '"<ul><li>Step 1</li></ul>"'
//    - a plain array (old data)       e.g. ["Step 1", "Step 2"]
//    - a plain string                 e.g. "Step 1"
const renderRichField = (field) => {
  if (!field) return null;

  // 1️⃣ Array — check if it contains HTML strings (new CKEditor format)
  if (Array.isArray(field)) {
    const isHtmlArray =
      field.length === 1 &&
      typeof field[0] === "string" &&
      field[0].trim().startsWith("<");

    if (isHtmlArray) {
      let html = field[0];
      try {
        const parsed = JSON.parse(html);
        if (typeof parsed === "string") html = parsed;
      } catch {
        /* use as-is */
      }
      return (
        <div
          className="ck-content"
          dangerouslySetInnerHTML={{ __html: html }}
        />
      );
    }

    // Old plain text array
    return (
      <ul>
        {field.map((item, idx) => (
          <li key={idx}>{item}</li>
        ))}
      </ul>
    );
  }

  // 2️⃣ JSON-stringified string — unwrap first
  let htmlString = field;
  if (typeof field === "string") {
    try {
      const parsed = JSON.parse(field);
      if (typeof parsed === "string") htmlString = parsed;
    } catch {
      /* use as-is */
    }
  }

  // 3️⃣ Render as HTML
  return (
    <div
      className="ck-content"
      dangerouslySetInnerHTML={{ __html: htmlString }}
    />
  );
};

const AsanaDetails = () => {
  const { slug } = useParams();
  const dispatch = useDispatch();

  const { selectedAsana, loading, error, sideAsanas } = useSelector(
    (state) => state.sideBarAsana,
  );

  // ─── Step 1: Make sure sidebar list is loaded ──────────────────────────────
  useEffect(() => {
    if (!sideAsanas || sideAsanas.length === 0) {
      dispatch(fetchSideBarAsanas({ name: "", level: "", poseType: "" }));
    }
  }, [dispatch, sideAsanas]);

  // ─── Step 2: Once sideAsanas is ready, find _id by slug and fetch ──────────
  useEffect(() => {
    if (!slug || !sideAsanas?.length) return;

    // Match by slug field from DB, or generate from name
    const match = sideAsanas.find((a) => (a.slug || makeSlug(a.name)) === slug);

    if (match?._id) {
      dispatch(fetchAsanaBySlug({ id: match._id })); // ✅ sends _id to backend
    }
  }, [dispatch, slug, sideAsanas]); // re-runs when sideAsanas loads

  if (loading) return <p className="page-padding">Loading...</p>;
  if (error) return <p className="page-padding error">{error}</p>;
  if (!selectedAsana) return <p className="page-padding">No data found.</p>;

  return (
    <div style={{ display: "flex", margin: "20px" }}>
      <div className="asana-container">
        <h1 className="asana-title">{selectedAsana.name}</h1>

        <div className="asana-image-wrapper">
          <img
            src={selectedAsana.mainImage}
            alt={selectedAsana.name}
            className="asana-image"
          />
        </div>

        <table className="asana-table">
          <tbody>
            <tr>
              <th>Sanskrit</th>
              <td>{selectedAsana.sanskrit}</td>
            </tr>
            <tr>
              <th>Tamil</th>
              <td>{selectedAsana.tamil}</td>
            </tr>
            <tr>
              <th>English</th>
              <td>{selectedAsana.english}</td>
            </tr>
            <tr>
              <th>Pose Type</th>
              <td>{selectedAsana.poseType?.join(", ")}</td>
            </tr>
            <tr>
              <th>Breath</th>
              <td>{selectedAsana.breath}</td>
            </tr>
            <tr>
              <th>Level</th>
              <td>
                {selectedAsana.level?.charAt(0).toUpperCase() +
                  selectedAsana.level?.slice(1)}
              </td>
            </tr>
            <tr>
              <th>Chakra</th>
              <td>{selectedAsana.chakra}</td>
            </tr>
          </tbody>
        </table>

        <div className="section">
          <h2>How To Do</h2>
          {renderRichField(selectedAsana.howToDo)}
        </div>

        <div className="section">
          <h2>Benefits</h2>
          {renderRichField(selectedAsana.benefits)}
        </div>

        <div className="section">
          <h2>Precautions</h2>
          {renderRichField(selectedAsana.precautions)}
        </div>

        <h2 style={{ marginBottom: "20px" }}>Variation Poses</h2>
        <div className="asana-variation">
          {selectedAsana.variationPoses?.length > 0 &&
            selectedAsana.variationPoses.map((v, i) => (
              <VariationCard v={v} key={v._id || i} />
            ))}

          {selectedAsana.userVariationPoses?.length > 0 &&
            selectedAsana.userVariationPoses.map((v, i) => (
              <VariationCard v={v} key={v._id || i} />
            ))}
        </div>
      </div>

      <AdvertisementCard />
    </div>
  );
};

export default AsanaDetails;
